var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBatteryHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 -0.5 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-battery-half",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1167") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 0.000000)",
    fill: "#434343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,13.448 C2,13.729 2.272,13.959 2.529,13.959 L6.441,13.959 C6.696,13.959 7,13.73 7,13.448 L7,5.069 L2,8.281 L2,13.448 L2,13.448 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.252,1 L6,1 L6,0.016 L3.023,0.016 L3.023,1 L1.715,1 C0.779,1 0.021,1.575 0.021,2.5 L0.021,14.325 C0.021,15.249 0.78,16 1.715,16 L7.251,16 C8.187,16 8.945,15.249 8.945,14.325 L8.945,2.5 C8.946,1.575 8.188,1 7.252,1 L7.252,1 Z M8,14 C8,14.516 7.516,15 7,15 L2,15 C1.485,15 1,14.516 1,14 L1,3 C1,2.486 1.485,1.949 2,1.949 L7,1.949 C7.516,1.949 8,2.485 8,3 L8,14 L8,14 Z",
    className: "si-glyph-fill"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryHalf);
export default __webpack_public_path__ + "static/media/battery_half.0cdd3d6d928e32e6e4e2bfa621bc5425.svg";
export { ForwardRef as ReactComponent };